"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_MORE = exports.INIT = exports.API_FETCHING_PAGINATION = exports.API_SWIPE_REFRESH = exports.API_FAILED = exports.API_PAGINATION_FINISHED = exports.API_SUCCESS = exports.API_FETCHING = exports.API_INITIAL = void 0;
exports.API_INITIAL = 0;
exports.API_FETCHING = 100;
exports.API_SUCCESS = 200;
exports.API_PAGINATION_FINISHED = 300;
exports.API_FAILED = 400;
exports.API_SWIPE_REFRESH = 500;
exports.API_FETCHING_PAGINATION = 600;
exports.INIT = 'INIT';
exports.LOAD_MORE = 'LOAD_MORE';
exports.default = {
    API_INITIAL: exports.API_INITIAL,
    API_FETCHING: exports.API_FETCHING,
    API_SUCCESS: exports.API_SUCCESS,
    API_PAGINATION_FINISHED: exports.API_PAGINATION_FINISHED,
    API_FAILED: exports.API_FAILED,
    API_SWIPE_REFRESH: exports.API_SWIPE_REFRESH,
    API_FETCHING_PAGINATION: exports.API_FETCHING_PAGINATION,
    INIT: exports.INIT,
    LOAD_MORE: exports.LOAD_MORE
};
//# sourceMappingURL=index.js.map